import { Map as ImmutableMap } from 'immutable';
import { createAction } from 'redux-actions';

import { rootUiActions, rootUiTypes } from 'companion-app-components/flux/root-ui';

import { DIALOG_TYPE as DIALOG_TYPE_WF_BILLS_SCOUT } from './types';

export const doWFBillsScout = createAction(
  rootUiActions.createDialog.toString(),
  () => rootUiTypes.mkRootUiData({
    id: 'DIALOG_WEBFIRST_BILLS_SCOUT',
    type: DIALOG_TYPE_WF_BILLS_SCOUT,
    allowNesting: false,
  }),
);

export const doWFBillsScoutBillIncomeFlow = createAction(
  rootUiActions.createDialog.toString(),
  (payload) => rootUiTypes.mkRootUiData({
    id: 'DIALOG_WEBFIRST_BILLS_SCOUT_INCOME_FLOW',
    type: DIALOG_TYPE_WF_BILLS_SCOUT,
    allowNesting: false,
    props: ImmutableMap({
      ...payload,
      billsIncomeFlow: true,
    }),
  }),
);
